import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom, Subject } from 'rxjs';
import { Lead } from '../models/lead';

@Injectable({
  providedIn: 'root'
})
export class LeadService {
  private apiUrl = '/api/leads';

  public leadCreated$: Subject<void> = new Subject();

  constructor(private readonly _http: HttpClient) {

  }

  public createLead(lead: Lead): Promise<void> {
    const observalble = this._http.post<void>(this.apiUrl, lead);
    return lastValueFrom(observalble);
  }
}
